import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FilterDefinitionItem, FilterDefinitionItemLocalDate } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';

import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { DirectDebitLog } from '../../model/direct-debit-log';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { ContactService } from '../../../rent/service/data/contact.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { DirectDebitLogService } from '../../service/data/direct-debit-log.service';

@Component({
    selector: 'app-direct-debit-log-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DirectDebitLogManagerComponent extends PagedObjectManagerComponent<DirectDebitLog> {
  constructor(
    private _dataService: DirectDebitLogService,
    private _companyService: CompanyService,
    private _contactService: ContactService,
    columnFactory: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = [
      columnFactory.createDateTime('COMMON.CREATED_DATE', 'createdAt', ColumnVisibility.mandatory),
      columnFactory.create('COMMON.COMPANY', 'companyName', ColumnVisibility.default),
      columnFactory.create('COMMON.CONTACT', 'contactName', ColumnVisibility.default),
      columnFactory.create('DIRECT_DEBIT_INFORMATION.PAYER_NUMBER', 'payerNumber', ColumnVisibility.default),
      columnFactory.create('INVOICE.INVOICE_NUMBER', 'invoiceNumber', ColumnVisibility.optional),
      columnFactory.create('COMMON.DESCRIPTION', 'description', ColumnVisibility.default),
    ];
    this.title = 'DASHBOARD.MENU.DIRECT_DEBIT_LOG';
    this.allowNew = false;
    this.allowOpenOnRowClick = false;
    this.preferencesKey = 'invoice.direct-debit-log.list';
  }

  ngOnInit() {
    super.ngOnInit();
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.filter.defaultFields;
        this.pageSize = definition.pageSize;
        const yesNo = [
          { caption: 'NO_TEXT', value: false },
          { caption: 'YES_TEXT', value: true },
        ];
        this.filterDefinition = [
          new FilterDefinitionItemLocalDate('COMMON.CREATED_DATE_FROM', 'showFrom', definition.filter.showFrom, true),
          new FilterDefinitionItem(
            'COMMON.COMPANY',
            'companyId',
            definition.filter.companyId,
            this._companyService,
            definition.filter.selectedFields.includes('companyId')
          ),
          new FilterDefinitionItem(
            'COMMON.CONTACT',
            'contactId',
            definition.filter.contactId,
            this._contactService,
            definition.filter.selectedFields.includes('contactId')
          ),
          new FilterDefinitionItem(
            'DIRECT_DEBIT_INFORMATION.PAYER_NUMBER',
            'payerNumber',
            definition.filter.payerNumber,
            null,
            definition.filter.selectedFields.includes('payerNumber')
          ),
          new FilterDefinitionItem(
            'INVOICE.INVOICE_NUMBER',
            'invoiceNumber',
            definition.filter.invoiceNumber,
            null,
            definition.filter.selectedFields.includes('invoiceNumber')
          ),
          new FilterDefinitionItem(
            'DIRECT_DEBIT.SHOW_PAYMENTS',
            'showPayments',
            definition.filter.showPayments,
            yesNo,
            definition.filter.selectedFields.includes('showPayments')
          ),
        ];
      })
    );
  }
}
